import { useEffect } from 'react';

 
export function useEmbedHeightReporter(formId: string | undefined, deps: unknown[]) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.self === window.top) return;
    const root = document.getElementById('root');
    if (!root) return;
 
    document.body.classList.add('form-builder-embedded');
    let last = 0;
    const post = () => {
      const height = Math.ceil(
        Math.max(root.scrollHeight, root.getBoundingClientRect().height),
      );
      if (!height || height === last) return;
      last = height;
      window.parent.postMessage(
        { type: 'form-builder:height', formId, height },
        '*',
      );
    };
    const observer = new ResizeObserver(post);
    observer.observe(root);
    post();
    return () => {
      observer.disconnect();
      document.body.classList.remove('form-builder-embedded');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId, ...deps]);
}
